import { render, staticRenderFns } from "./BoxInnerDepth.vue?vue&type=template&id=5b10a559&"
import script from "./BoxInnerDepth.vue?vue&type=script&lang=ts&"
export * from "./BoxInnerDepth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports